<template lang="pug">
  v-app
    Header(
      @close="close"
      @openCart="openCart"
      @openOrder="openOrder"
    )
    v-main#dinein(
      v-if="decrypted"
      class="padded-bottom"
    )
      .homepage
        router-view(
          :decrypted="decrypted"
          :details="details"
          :constraints="constraints"
        )
        Cart(
          v-if="dialogCart"
          :dialog="dialogCart"
          :details="details"
          :decrypted="decrypted"
          @close="close"
        )
        Order(
          v-if="dialogOrder"
          :dialog="dialogOrder"
          :details="details"
          :decrypted="decrypted"
          @close="close"
        )
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import Footer from "@/views/home/Footer";
import Header from "@/views/dinein/Header";
import Cart from "@/views/dinein/Cart";
import Order from "@/views/dinein/Order";

export default {
  components: {
    Footer,
    Header,
    Cart,
    Order
  },
  data() {
    return {
      details: null,
      constraints: [],
      decrypted: null,
      dialogCart: false,
      dialogOrder: false,
      drawer: false,
      group: null,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    merchantId() {
      return this.decrypted.merchant_id;
    },
    storeId() {
      return this.decrypted.store_id;
    },
    tableId() {
      return this.decrypted.table_id;
    }
  },
  mounted() {
    this.decrypt();
    this.getMerchantDetails();
    this.$store.commit("customer/updateUrl", this.$route.path);
  },
  methods: {
    getMerchantDetails() {
      let url = config.detailsUrl();

      var json = {
        params: {
          location_latitude: this.$store.getters.latitude,
          location_longitude: this.$store.getters.longitude,
          merchant_id: this.merchantId,
          store_id: this.storeId,
          table_id: this.tableId,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.details = response.body.data[0];
                this.constraints = response.body.data_2;

                document.title = `${this.details.store_name} [${this.details.merchant_name}] - Anybook`;

                // this.$store.commit("customer/storeConstraint", this.constraints);
                // this.deleteConstraintsWithZeroValue();
              } else {
                this.$swal(
                  this.$t("error.get_merchant_details"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_details"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_details"),
            response.body.message,
            "error"
          );
        });
    },
    decrypt() {
      this.decrypted = JSON.parse(
        this.$helpers.decrypt(
          decodeURIComponent(this.$route.query.q).replace(/ /g, "+")
        )
      );
    },
    close() {
      this.dialogCart = false;
      this.dialogOrder = false;
    },
    openCart() {
      this.dialogCart = true;
      this.dialogOrder = false;
    },
    openOrder() {
      this.dialogOrder = true;
      this.dialogCart = false;
    }
  }
};
</script>
